const documentClass = () => {
 const CLASS_MOBILE = `is-mobile`;
 const CLASS_DEVICE = `is-mobile-device`;
 const CLASS_IOS = `is-ios`;
 const CLASS_ANDROID = `is-android`;

 const CLASS_VIEW_PC = `is-view-mode-pc`;
 const CLASS_VIEW_MOBILE = `is-view-mode-mobile`;

 const CLASS_SCROLLING = `is-scrolling`;
 const CLASS_OVERLAY_SCROLL = `is-overlay-scroll`;

 const CLASS_PC_VIEW = `is-pc-view`;
 const CLASS_MOBILE_VIEW = `is-mobile-view`;

 const CLASS_IS_LOADING = `is-dom-loading`;
 const CLASS_FOCUS_VISIBLE = `is-focus-visible`;

 const MOBILE_VIEW_SIZE = 1000;
 const MEDIA_QUERY_LIST = matchMedia(`(width < ${MOBILE_VIEW_SIZE}px)`);

 const HTML = document.documentElement;
 const SEARCH_PARAMS = new URLSearchParams(window.location.search);

 let viewMode = SEARCH_PARAMS.get(`feViewMode`);
 let isDevice = false;

 let isScrolling;

 const handleScroll = () => {
 HTML.classList.add(CLASS_SCROLLING);
 clearTimeout(isScrolling);

 isScrolling = setTimeout(() => HTML.classList.remove(CLASS_SCROLLING), 50);
 };

 // const handleResize = () => {
 // // Add loading class
 // if (!HTML.matches(`.${CLASS_IS_LOADING}`)) {
 // HTML.classList.add(CLASS_IS_LOADING);
 // }

 // if (window.innerWidth < MOBILE_VIEW_SIZE) {
 // HTML.classList.add(CLASS_MOBILE_VIEW);
 // HTML.classList.remove(CLASS_PC_VIEW);
 // } else {
 // HTML.classList.add(CLASS_PC_VIEW);
 // HTML.classList.remove(CLASS_MOBILE_VIEW);
 // }

 // // Remove loading class
 // setTimeout(() => {
 // HTML.classList.remove(CLASS_IS_LOADING);
 // });
 // };

 const endNoAnimNextFrame = () => {
 requestAnimationFrame(() => {
 requestAnimationFrame(() => {
 HTML.classList.remove(CLASS_IS_LOADING);
 });
 });
 };

 const handleMatchMediaChange = (e) => {
 // Add loading class
 !HTML.matches(`.${CLASS_IS_LOADING}`) &&
 HTML.classList.add(CLASS_IS_LOADING);

 // const isPreviousPcView = HTML.matches(`.${CLASS_PC_VIEW}`);
 // const isPreviousMobileView = HTML.matches(`.${CLASS_MOBILE_VIEW}`);
 const isForcedPc = viewMode === `pc`;
 const isForcedMobile = viewMode === `mobile`;
 const isCurrentMobileView = isForcedMobile
 ? true
 : isForcedPc
 ? false
 : e.matches;
 const isCurrentPcView = !isCurrentMobileView;

 HTML.classList.toggle(CLASS_PC_VIEW, isCurrentPcView);
 HTML.classList.toggle(CLASS_MOBILE_VIEW, isCurrentMobileView);

 // if (documentClass.callback) {
 // const viewInfo = {
 // isPreviousPcView,
 // isPreviousMobileView,
 // isCurrentPcView,
 // isCurrentMobileView,
 // };

 // if (typeof documentClass.callback === `function`) {
 // documentClass.callback(viewInfo);
 // } else if (typeof documentClass.callback === `object`) {
 // for (let funcName in documentClass.callback) {
 // if (typeof documentClass.callback[funcName] === `function`) {
 // documentClass.callback[funcName](viewInfo);
 // }
 // }
 // }
 // }

 // Remove loading class
 // setTimeout(() => {
 // HTML.classList.remove(CLASS_IS_LOADING);
 // });
 endNoAnimNextFrame();
 };

 const applyViewTypeClass = () => {
 // View mode
 viewMode === `pc` && HTML.classList.add(CLASS_VIEW_PC);
 viewMode === `mobile` &&
 HTML.classList.add(CLASS_MOBILE, CLASS_VIEW_MOBILE);

 // User agent
 const ua = navigator.userAgent;

 if (/iPhone|iPad|iPod/i.test(ua)) {
 viewMode !== `pc` && HTML.classList.add(CLASS_MOBILE);
 HTML.classList.add(CLASS_IOS, CLASS_DEVICE);
 isDevice = true;
 }

 if (/Android/i.test(ua)) {
 viewMode !== `pc` && HTML.classList.add(CLASS_MOBILE);
 HTML.classList.add(CLASS_ANDROID, CLASS_DEVICE);
 isDevice = true;
 }

 // Set Cookie
 viewMode === `pc` && isDevice
 ? FEUI.controlCookie?.add(`feViewMode`, `pc`, 30)
 : FEUI.controlCookie?.remove(`feViewMode`);

 // Reset mobile
 viewMode === `pc` && HTML.classList.remove(CLASS_MOBILE);
 };

 const applyScrollTypeClass = () => {
 const testEl = document.createElement(`div`);
 testEl.style.cssText = `
 overflow: scroll;
 inline-size: 5rem;
 block-size: 5rem;
 position: absolute;
 inset-block-start: -999dvb;
 `;

 document.body.appendChild(testEl);

 testEl.offsetWidth === testEl.clientWidth
 ? HTML.classList.add(CLASS_OVERLAY_SCROLL)
 : HTML.classList.remove(CLASS_OVERLAY_SCROLL);

 document.body.removeChild(testEl);
 };

 const focusVisibleClass = (event) => {
 HTML.classList.toggle(CLASS_FOCUS_VISIBLE, event.type !== `mousedown`);
 };

 const initialize = () => {
 viewMode = FEUI.controlCookie?.get(`feViewMode`) || viewMode;

 applyViewTypeClass();
 // handleResize();
 handleMatchMediaChange({
 matches: MEDIA_QUERY_LIST.matches,
 });

 window.addEventListener(`scroll`, handleScroll, {
 passive: true,
 });
 // window.addEventListener(`resize`, handleResize);

 MEDIA_QUERY_LIST.addEventListener(`change`, handleMatchMediaChange);

 document.addEventListener(`DOMContentLoaded`, applyScrollTypeClass);
 document.body.addEventListener(`mousedown`, focusVisibleClass);
 document.addEventListener(`keydown`, focusVisibleClass);
 };

 initialize();

 // documentClass.update = handleResize;
 documentClass.update = () => {
 handleMatchMediaChange({
 matches: MEDIA_QUERY_LIST.matches,
 });
 };

 documentClass.cleanup = () => {
 window.removeEventListener(`scroll`, handleScroll);
 // window.removeEventListener(`resize`, handleResize);

 MEDIA_QUERY_LIST.removeEventListener(`change`, handleMatchMediaChange);

 document.removeEventListener(`DOMContentLoaded`, applyScrollTypeClass);
 document.body.removeEventListener(`mousedown`, focusVisibleClass);
 document.removeEventListener(`keydown`, focusVisibleClass);

 clearTimeout(isScrolling);
 };
};

export default documentClass;
